import { ActionTree, MutationTree, Module } from 'vuex';

export interface Article {
	id: number;
	quantity: number;
	formulaNumber:number | null;
	item: any;
	targetDate: Date | null;
	remaining: number;
}

export class Cart {
	items: Article[] = [];
	total: number = 0;
	totalWithCurrency: string = "";
	get nbItems() {
		return this.items.reduce((prev, curr) => prev + curr.quantity, 0);
	}
}


/** SUITE : pour l'instant inutile */
export interface ShopState {
	dateBooked: Date | null;
	serviceBooked: any | null;
	userBooked: any | null;
	cart: Cart | null;
}

const initialState: ShopState = {
	dateBooked: null,
	serviceBooked: null,
	userBooked: null,
	cart: null,
};

const mutations: MutationTree<ShopState> = {

};


const actions: ActionTree<ShopState, any> = {

};

export const bookingShop: Module<ShopState, any> = {
	namespaced: true,
	state: initialState,
	actions,
	mutations
};
